import Cookies from 'js-cookie'

const COOKIE_EXPIRATION = 30 // days
const LONG_TERM_EXPIRATION = 365 // days

export default class UtmCookies {
    static utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
    static firstSourceKey = 'utm_source_first'
    static cookiePrefix = '_presence_'

    static getParamsFromCookies () {
        return UtmCookies.utmParams.reduce((acc, param) => {
            acc[param] = Cookies.get(`${UtmCookies.cookiePrefix}${param}`) || ''
            return acc
        }, {})
    }

    static getParamFromCookies (param) {
        return Cookies.get(`${UtmCookies.cookiePrefix}${param}`) || ''
    }

    constructor () {
        if (this.checkDNT()) return

        const params = this.getParams()
        if (Object.keys(params).length && params.utm_source !== 'hs_automation') {
            this.storeParamsInCookies(params)
            this.storeFirstSource(params)
        }
    }

    checkDNT () {
        return ['1', 'yes'].includes(window.navigator.doNotTrack || window.doNotTrack || window.navigator.msDoNotTrack)
    }

    storeParamsInCookies (params) {
        UtmCookies.utmParams.forEach(key => {
            Cookies.set(`${UtmCookies.cookiePrefix}${key}`, params[key] || '', { expires: COOKIE_EXPIRATION })
        })
    }

    storeFirstSource (params) {
        const firstSourceKey = `${UtmCookies.cookiePrefix}${UtmCookies.firstSourceKey}`

        if (!Cookies.get(firstSourceKey) && params.utm_source)
            Cookies.set(firstSourceKey, params.utm_source, { expires: LONG_TERM_EXPIRATION })
    }

    getParams () {
        const params = {}
        const urlParams = new URLSearchParams(window.location.search)

        UtmCookies.utmParams.forEach(param => {
            if (urlParams.has(param))
                params[param] = urlParams.get(param)
        })

        return params
    }
}
